import { combineReducers } from 'redux';

import contract_globals from './Contracts.Globals.Reducer';
import reports from './Reports.Reducer';
import fees from './Contract.Fees.Reducer';
import teams from './Contract.Teams.Reducer';
import templates from './Contract.Templates.Reducer';
import allocation from './Script.Allocation.Reducer';
import scriptdates from './Script.Dates.Reducer';
import appointeeReducer from './Appointee.Contract.Reducer';
import amendContractReducer from './AmendContract.Reducer';
import user from './User.Reducer';

const rootReducer = combineReducers({
	contract_globals,
	reports,
	teams,
	fees,
	templates,
	allocation,
	scriptdates,
	appointeeReducer,
	amendContractReducer,
	user
});

export default rootReducer;
